<script>
import img from '../assets/FreeIssue-LetterSantaClous.png'
import bottomImg from '../assets/bottom-img.png'
import mobileBottomImg from '../assets/mobile-bottom-img.png'

export default {
	pageView: true,
	data() {
		return {
			img,
			bottomImg,
			mobileBottomImg,
			loading: false,
			error: false,
			validation: {},
			defaultInscription: `Quiero contarte que estoy muy feliz porque ya casi es Navidad y este año ¡me porté excelente! Seguramente estás ocupado organizando todo, pero quería enviarte`,
			form: {
				nameTo: null,
				nameFrom: 'Papá Noel',
				email: null,
				inscription: ``,
			},
		}
	},
	computed: {
		isMobile() {
			return this.$vuetify.breakpoint.xs
		},
	},
	methods: {
		submitForm() {
			if (this.error) return
			if (this.$route.query.origin) {
				this.form.origin = this.$route.query.origin
			}
			this.form.inscription = this.form.inscription || this.defaultInscription
			this.$shopApi.post({
				url: '/free-issue-form/letter-santa-clous',
				data: this.form,
				loading: (v) => (this.loading = v),
				onValidation: ({ validation }) => (this.validation = validation),
				done: ({ success }) => {
					if (success) {
						this.$router.push({
							name: 'others.free-issue-thanks',
							params: { key: 'letter-santa-clous', email: this.form.email },
							query: this.$route.query,
						})
					} else {
						this.error = true
						setTimeout(() => (this.error = false), 4000)
					}
				},
			})
		},
	},
	mounted() {
		this.$prerenderReady()
		console.log('created')
	},
}
</script>
<template>
	<div class="page-bg-container">
		<div class="d-flex flex-column align-center justify-center pb-10">
			<Container width="800px">
				<div class="darkblue--text font-weight-bold text-center mb-3 font-6 font-md-10">
					¡Crea tu carta personalizada para Papá Noel GRATIS!
				</div>
				<div class="text-center mb-3 font-2">
					Simplemente agrega el nombre de tu peque, descarga la tarjeta de deseos para colorear que
					enviamos a tu mail, imprímela ¡y que comience la magia de la Navidad!
				</div>
			</Container>
			<div class="darkblue w100 my-10">
				<Container>
					<v-row>
						<v-col cols="12" md="6" class="pt-0">
							<Media :src="img" width="100%" contain></Media>
						</v-col>
						<v-col cols="12" md="6" class="py-10">
							<div class="white--text font-6 text-center mb-8">
								Ingresa estos datos <br />
								¡y recibe tu carta ahora mismo!
							</div>
							<Validator :validation="validation">
								<div>
									<label class="white--text">Esta carta es para</label>
									<TextField
										v-model="form.nameFrom"
										validator-key="nameFrom"
										readonly
										label="Este cart personalizado es para"
										class="customization-tf mb-3"
										solo
										height="50"
										counter="14"
										maxlength="14"
									/>
									<label class="white--text">De parte de</label>
									<TextField
										v-model="form.nameTo"
										validator-key="nameTo"
										placeholder="Nombre de tu peque"
										class="customization-tf mb-3"
										solo
										height="50"
										counter="14"
										maxlength="14"
									/>
									<label class="white--text">Tu correo</label>
									<TextField
										v-model="form.email"
										validator-key="email"
										placeholder="Tu dirección de correo electrónico"
										class="customization-tf mb-3"
										solo
										height="50"
									/>
									<label class="white--text">Mensaje para Papa Noel</label>
									<Textarea
										v-model="form.inscription"
										validator-key="inscription"
										class="customization-tf mb-3"
										solo
										:placeholder="defaultInscription"
										counter="130"
										maxlength="130"
									/>
								</div>
							</Validator>
							<Button
								:color="error ? 'white' : 'orange'"
								:text="error"
								class="white--text px-15 mt-8"
								block
								x-large
								@click="submitForm"
								:loading="loading"
							>
								<span v-if="error">Oops! Ocurrio un error. Intenta nuevamente.</span>
								<span v-else>Crea tu carta</span>
							</Button>
						</v-col>
					</v-row>
				</Container>
			</div>
			<Media
				:src="isMobile ? mobileBottomImg : bottomImg"
				width="100%"
				max-width="950px"
				max-height="350px"
				contain
			/>
		</div>
	</div>
</template>

<style scoped>
.input {
	border-right: 1px solid lightgray;
}
.input >>> input {
	color: var(--v-darkblue-base);
}
.v-text-field ::v-deep .v-counter {
	color: white;
}
</style>
